import { j as s } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ s.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 80", fill: "currentColor", children: [
  /* @__PURE__ */ s.jsx("path", { d: "M0 40C0 17.908 17.908 0 40 0s40 17.908 40 40-17.908 40-40 40S0 62.092 0 40M40 8a32 32 0 1 0 0 64 32 32 0 0 0 0-64" }),
  /* @__PURE__ */ s.jsx("path", { d: "M44 20a4 4 0 1 0-8 0v16H20a4 4 0 1 0 0 8h16v16a4 4 0 1 0 8 0V44h16a4 4 0 1 0 0-8H44z" })
] });
export {
  r as A
};
